
export const csvheaders = [
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "account holder", key: "account_holder" },
    { label: "email", key: "email" },
    { label: "status", key: "status" },
    { label: "company", key: "name" },
    { label: "employment identifier", key: "employment_identifier" },
    { label: "ESID", key: "esid" },
    { label: "CA#", key: "ca_number" },
    { label: "check digit", key: "check_digit" },
    { label: "language preference", key: "language_preference" },
    { label: "Date Registered", key: "date_registered" },
];


export const filterKeys = {
    keys: ['status', 'company', 'registered_date'], //a list of all keys in keyValues array
    keyValues: [
        {
            key: 'status', //key for db 
            label: "Status", //pretty label for site
            values: ['All', 'PENDING', 'ACTIVE', 'SUSPENDED', 'UNVERIFIED', 'REFUSED', 'REMINDER', 'QUARTERLY', 'ERROR'] // all filter options
        },
        //repeat for all filters
        {
            key: 'name',
            label: "Company",
            values: ['All']
        },
        {
            key: 'registered_date',
            label: "Date Registered",
            values: ['All', 'Today', 'Past 7 days', 'This Month', 'This Year']
        }
    ]
}


export const tableColumns = [
    {
        label: "Select All",
        field: "selectInput",
        sort: "asc",
        width: 50,
    },
    {
        label: 'Registrant Name',
        field: 'fullname',
        sort: 'asc',
        width: 50
    },
    {
        label: 'Company',
        field: 'name',
        sort: 'asc',
        width: 100
    },
    {
        label: 'Date Registered',
        field: 'registered_date',
        sort: 'asc',
        width: 100
    },
    {
        label: 'Status',
        field: 'statusSelect',
        sort: 'asc',
        width: 200
    },
    {
        label: 'Actions',
        field: 'actions',
        sort: 'asc',
        width: 50
    }
];